module.exports = __webpack_public_path__ + "img/item16.03626a72.png";